var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm._l(_vm.inputSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  i === 0
                    ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                        _vm._v(" ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    form.value.length > 0
                      ? _c(
                          "p",
                          { staticClass: "mg-b-0 text-left" },
                          _vm._l(form.value, function(form1, i) {
                            return form1.codeCode == _vm.receptionData[form.id]
                              ? _c("span", [_vm._v(_vm._s(form1.codeName))])
                              : _vm._e()
                          }),
                          0
                        )
                      : form.name == "Reception No"
                      ? _c("p", { staticClass: "mg-b-0 text-left" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#modal5",
                                "data-toggle": "modal",
                                "data-animation": "effect-flip-horizontal"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.sendId(_vm.properties.uid)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.receptionData[form.id]))]
                          )
                        ])
                      : _c("p", { staticClass: "mg-b-0 text-left" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.receptionData[form.id]) +
                              "\n                        "
                          )
                        ])
                  ])
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: " d-block has-text-weight-semibold",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.value, function(form1, j) {
                        return _vm.receptionData[form.id] == form1.codeCode
                          ? _c("p", { staticClass: "mg-b-0 text-left" }, [
                              _vm._v(_vm._s(form1.codeName))
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mg-b-0 text-left" }, [
                      _vm._v(_vm._s(_vm.receptionData[form.id]))
                    ])
                  ])
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components overflow-hidden" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " View")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      attrs: {
                        to: {
                          name: this.$route.name.replace("_completion", ""),
                          params: { mid: this.properties.mid, type: "list" }
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "wd-10 mg-r-5",
                        attrs: { "data-feather": "file" }
                      }),
                      _vm._v("list")
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25" },
            [
              _c("div", { staticClass: "d-none d-md-block tx-right-f" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                    attrs: {
                      href: "",
                      "data-toggle": "modal",
                      "data-animation": "effect-flip-horizontal"
                    },
                    on: {
                      click: function($event) {
                        return _vm.excelExport()
                      }
                    }
                  },
                  [
                    _c("feather", {
                      staticClass:
                        "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                      attrs: { type: "file-text" }
                    }),
                    _vm._v("Excel")
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.buttonFlag
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                        attrs: {
                          href: "",
                          "data-toggle": "modal",
                          "data-animation": "effect-flip-horizontal"
                        },
                        on: {
                          click: function($event) {
                            return _vm.ToMediageSendDataApi()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "clipboard" }
                        }),
                        _vm._v("Result Report")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.buttonFlag
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f",
                        attrs: {
                          href: "",
                          "data-toggle": "modal",
                          "data-animation": "effect-flip-horizontal"
                        },
                        on: {
                          click: function($event) {
                            return _vm.cancellationMediage()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "x-circle" }
                        }),
                        _vm._v("Cancel")
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "b-table",
                    {
                      staticClass: "overflow-x-hidden b-table-fix-header",
                      attrs: {
                        id: "btable",
                        data: _vm.isEmpty ? [] : _vm.sampleData,
                        "checked-rows": _vm.checkedRows,
                        checkable: "",
                        hoverable: "",
                        striped: ""
                      },
                      on: {
                        "update:checkedRows": function($event) {
                          _vm.checkedRows = $event
                        },
                        "update:checked-rows": function($event) {
                          _vm.checkedRows = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _vm._l(_vm.sampleHeader, function(form, i) {
                                return i == 0
                                  ? _c(
                                      "b-table-column",
                                      {
                                        key: i,
                                        attrs: { field: "no", label: "No" }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(props.row.no) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.sampleHeader, function(form, i) {
                                return i > 0
                                  ? _c(
                                      "b-table-column",
                                      {
                                        key: i,
                                        attrs: {
                                          field: form.columnCode,
                                          label: form.columnName,
                                          centered: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(props.row[form.columnCode]) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              })
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered"
                            },
                            [_c("p", [_vm._v("Nothing here.")])]
                          )
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-header" }, [
      _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
        _c("i", { attrs: { "data-feather": "x" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86f7bc9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86f7bc9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contract/CompletionForm.vue
// module id = null
// module chunks = 